import React, { useRef } from "react";
import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import {Paragraph} from "@arctheme-components/elements/Paragraph/Paragraph";
import {Headings} from "@arctheme-components/elements/Headings/Headings";
import Tile from "@src/stories/components/Tile/Tile";

export default function Scrollable({
    settings,
    columns,
    headerText,
    subtext,
    tagline,
    columns_count,
    additional
 }) {
    const { section } = settings;
    // const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
    const isMobile = useMobileBreakpoint("1024px");

    const parsedAdditional = JSON.parse(additional || "[]")

    const isFirstColumnDefaultLayout = columns[0]?.settings.layout === "default";
    let firstBlockHeight = isMobile
        ? columns[0]?.settings.mobile_block_height
        : columns[0]?.settings.block_height;

    if (!isFirstColumnDefaultLayout) {
        firstBlockHeight = 0;
    }
    const gapBetweenBlocksX = isMobile
        ? settings.section.gap_mobile
        : settings.section.gap;
    const gapBetweenBlocksY = isMobile
        ? settings.section.gap_y_mobile
        : settings.section.gap_y;

    const titleStyle = isMobile
        ? settings.section.header_style_mobile
        : settings.section.header_style;

    const taglineStyle = isMobile
        ? settings.section.tagline_style_mobile
        : settings.section.tagline_style;

    const contentStyle = isMobile
        ? settings.section.subtext_style_mobile
        : settings.section.subtext_style;

    const layoutType = isMobile
        ? settings.section.layout_mobile
        : settings.section.layout;
    return (
        <div className={`multicolumn-${layoutType} overflow-hidden`}>
            {(tagline || headerText || subtext) && (
                <div className="multicolumn-content-top w-full lg:w-[700px] my-[16px]">
                    {tagline && <Paragraph text={tagline} type={taglineStyle}/>}
                    {headerText && <Headings text={headerText} type={titleStyle}/>}
                    {subtext && <Paragraph text={subtext} type={contentStyle}/>}
                </div>
            )}

            <div
                className={`scrollable flex w-full lg:h-[${firstBlockHeight}px] 
                overflow-x-scroll
                justify-${settings.section.content_alignment_mobile} 
                lg:justify-${settings.section.content_alignment_desktop}`}
                style={{ display: "-webkit-inline-box" }}
            >
                {columns.map((column, index) => {
                    const columnWidth = isMobile
                        ? column.settings.width_mobile
                        : column.settings.width;
                    const defaultFlexBasis = `${100 / columns_count}%`;
                    const flexBasis =
                        columnWidth > 0
                            ? `calc(${columnWidth}% - ${gapBetweenBlocksX}px)`
                            : `calc(${defaultFlexBasis} - ${gapBetweenBlocksX}px)`;
                    const columnHeight = isMobile
                        ? column.settings.mobile_block_height
                        : column.settings.block_height;
                    const heightStyle = columnHeight > 0 ? `${columnHeight}px` : "auto";

                    const imageAlt = parsedAdditional[index]?.image_alt || column.settings?.title || "Image alt";

                    return (
                        <div
                            key={column.key || index}
                            style={{
                                flexBasis,
                                height: column.settings.layout == "default" && heightStyle,
                                marginLeft:
                                    !settings.section.use_carousel &&
                                    index % columns_count !== 0
                                        ? `${gapBetweenBlocksX / 2}px`
                                        : 0,
                                marginRight:
                                    !settings.section.use_carousel &&
                                    (index + 1) % columns_count !== 0
                                        ? `${gapBetweenBlocksX / 2}px`
                                        : 0,
                                marginTop: `${gapBetweenBlocksY / 2}px`,
                                marginBottom: `${gapBetweenBlocksY / 2}px`,
                                ...(settings.section.use_carousel && {
                                    marginLeft: `${gapBetweenBlocksX / 2}px`,
                                    marginRight: `${gapBetweenBlocksX / 2}px`,
                                }),
                            }}
                            className="overflow-hidden carbox-border"
                        >
                            <Tile
                                data={{ ...column, image_alt: imageAlt }}
                                layout={column.settings.layout}
                                height={heightStyle}
                                settings={settings}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}